// Create a new file that exports App in both ways
import App from './App.jsx';  // Assuming App.jsx is the source file
console.log("AppExports loaded App:", typeof App);

export { App };
export default App; 